import Slider from "@mui/material/Slider";
import { isIOS } from "react-device-detect";

const CustomSlider = (props) => {
  const handleChange = (x) => {
    if (
      x.type === "mousedown" &&
      (isIOS || navigator.userAgent === "Expo iOS")
    ) {
      return;
    }
    if (props.onChange) {
      props.onChange(x);
    }
  };

  return <Slider {...props} onChange={handleChange} />;
};

export default CustomSlider;
